var _defs, _circle, _path, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptoCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cryptoCoinRim",
    x1: 5,
    y1: 4,
    x2: 19,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5C518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4920E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cryptoCoinFace",
    x1: 8,
    y1: 8,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4920E"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "url(#cryptoCoinRim)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.75C8.65 6.45 11.35 5.25 14 5.75",
    stroke: "#FFF2A8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    opacity: 0.65
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.25,
    fill: "url(#cryptoCoinFace)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.25,
    stroke: "#C8890A",
    strokeWidth: 0.5,
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.35 8.15C13.45 7.35 11.05 7.65 9.55 9.15C8.15 10.55 8.15 13.45 9.55 14.85C11.05 16.35 13.45 16.65 15.35 15.85L14.55 14.45C13.15 14.95 11.75 14.65 10.95 13.45C10.25 12.35 10.25 11.65 10.95 10.55C11.75 9.35 13.15 9.05 14.55 9.55L15.35 8.15Z",
    fill: "#FFF5D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoCoin);
export default __webpack_public_path__ + "static/media/cryptoCoin.cd831ebb5d3abb5feff20c307dc04dc9.svg";
export { ForwardRef as ReactComponent };